import * as React from 'react';

import View from './view';
import {ProductsAcceptorFilterViewBaseProps} from '../../../model';

export const ProductsAcceptorFilterVisuallyImpaired: React.FC<ProductsAcceptorFilterViewBaseProps> = (props) => {
  return <View {...props} />;
};
